// @ts-nocheck
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Loader from '../../../../components/Shared/Loader/Loader';
import { useTranslation } from 'react-i18next';
import AddExtraInformationForm from './AddExtraInformationDynamicType.jsx';
import Pagination from '../../../../components/Shared/Pagination/Pagination.jsx';
import { Card, CardBody } from '../../../../components/card/card';
import ModalComponent from '../../../../components/Modal/ModalComponent';
import useGetDynamicForm from '../../../../hooks/Forms/useGetDynamicForm';
import Breadcrumb from '../../../../components/Shared/Breadcrumb';
import NtxTable from '@components/DataTable/NtxTable.jsx';
import Loading from '@components/Shared/Loader/Loading';

// يستقبل الجدول الجاي منه مع الموديول والأسم
const ExtraInformationDynamicType = ({ moduleId, TableId, Name }) => {
  const [Show, setShow] = useState(false);
  const { t, i18n } = useTranslation();
  const [search, setSearch] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [dataPerPage] = useState(10);
  const Navigate = useNavigate();

  const { DynamicExtraType, loading } = useGetDynamicForm();

  //_________________________________________________________________________________________________

  const filtered = DynamicExtraType?.slice()
    ?.filter(item => {
      const searchLowerCase = search.toLowerCase();
      return (
        item.name?.toLowerCase().includes(searchLowerCase) ||
        item.name2?.toLowerCase().toString().includes(searchLowerCase)
      );
    })
    ?.filter(item => item.moduleId === moduleId);

  const indexOfLastData = currentPage * dataPerPage;
  const indexOfFirstData = indexOfLastData - dataPerPage;
  const currentData = filtered?.slice(indexOfFirstData, indexOfLastData);

  const columns = [
    { title: t('النوع'), key: 'type' },
    { title: t('الأيقونة'), key: 'Icon' },

    { title: '', key: 'action', className: 'text-end' }
  ];

  const tableData = DynamicExtraType?.map(item => {
    let rowClass;
    // يمكنك تحديد rowClass بناءً على شرط معين، مثلاً:
    // rowClass = item.isExpired ? 'table-danger' : '';

    return {
      type: i18n.language === 'ar' ? item.name2 : item.name,
      Icon: (
        <div className='text-theme fs-5'>
          <i className={item.icon}></i>
        </div>
      ),

      action: (
        <>
          <button
            type='button'
            onClick={() => Navigate(`/NTX/Forms/${item.id}/AddFormColumns`)}
            className='btn btn-sm btn-outline-theme me-2'
          >
            <i className='fab fa-lg fa-fw me-2 fa-elementor'></i>
            {t('fieldsForm')}
          </button>

          <button type='button' onClick={() => Navigate(`${item.id}/Edit`)} className='btn btn-sm btn-outline-theme'>
            <i className='far fa-lg fa-fw me-2 fa-edit'></i>
            {t('Button.Edit')}
          </button>
        </>
      ),

      rowClass // يمكنك استخدامها لتلوين الصف حسب الحالة
    };
  });

  //________________________________
  var BcrumbList = [
    {
      name: 'Home',
      link: ':moduleHome'
    },
    {
      name: Name,
      link: null
    }
  ];

  return (
    <>
      <div className='d-flex align-items-center'>
        <Breadcrumb BreadcrumbList={BcrumbList} PageName={Name} />

        <div className='ms-auto'>
          <a
            href='#/'
            className='btn btn-theme'
            data-bs-toggle='modal'
            data-bs-target='#modalAddForm'
            onClick={() => setShow(true)}
          >
            <i className='fa fa-plus-circle fa-fw me-1'></i>
            {t('نوع جديـد')}
          </a>
        </div>
      </div>

      <Card>
        <Loading loading={loading}>
          <CardBody>
            <NtxTable
              data={tableData || []}
              columns={columns}
              dataPerPage={10}
              theadClass=''
              tableClass='table text-nowrap table-hover '
              enableSearch
              showRecordsSelector
            />
          </CardBody>
        </Loading>
      </Card>

      <ModalComponent title={`اضافة ${Name}`} id='modalAddForm' size='sm'>
        {Show && <AddExtraInformationForm moduleId={moduleId} TableId={TableId} />}
      </ModalComponent>
    </>
  );
};

export default ExtraInformationDynamicType;
